import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';
import Customers from './Pages/Customers';
import AddCustomers from './Pages/AddCustomers';
import superadmin from './Pages/superadmin/superadmin';
import adminfaculty from './Pages/adminfaculty/adminfaculty';
import superadmininside from './Pages/superadmin/superadmininside';
import superadminstatus from './Pages/superadmin/superadminstatus';
import expert from './Pages/expert/expert';
import superadminaddress from './Pages/superadmin/superadminaddress';
import adminfacultyproportion from './Pages/adminfaculty/adminfacultyproportion';
import superadminlistregister from './Pages/superadmin/superadminlistregister';
import superadmincertificate from './Pages/superadmin/superadmincertificate';
import Leftmenu from './Pages/adminfaculty/Leftmenu';
import Search from './Pages/adminfaculty/Search';
import adminfacultyi from './Pages/adminfaculty/adminfacultyi';
import adminfacultyst1 from './Pages/adminfaculty/adminfacultyst1';
import adminfacultyst2 from './Pages/adminfaculty/adminfacultyst2';
import adminfacultyst3 from './Pages/adminfaculty/adminfacultyst3';
import adminfacultyst4 from './Pages/adminfaculty/adminfacultyst4';
import adminfacultyst5 from './Pages/adminfaculty/adminfacultyst5';
import adminfacultyst6 from './Pages/adminfaculty/adminfacultyst6';
import adminfacultyst7 from './Pages/adminfaculty/adminfacultyst7';
import adminfacultya from './Pages/adminfaculty/adminfacultya';
import adminfacultyfortabian from './Pages/adminfaculty/adminfacultyfortabian';
import adminfacultyst8 from './Pages/adminfaculty/adminfacultyst8';





//import Footter from './Component/Footter';

export default class Routes extends Component {
    render() {
        return (
            <Router basename="grade" >
                <Header />
                <MDBContainer fluid>
                     {/* { localStorage.getItem('loginstatus') != 1 ? <><MDBCol xl=""></MDBCol></> :<> <MDBCol xl="2"> <Leftmenu/> </MDBCol></>} */}
                <MDBRow>
                  
                    <MDBCol xl="12"  className="d-flex justify-content-center">
                <br/>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/About" component={About} />
                    <Route exact path="/Customers" component={Customers} />
                    <Route exact path="/AddCustomers" component={AddCustomers} />
                    <Route exact path="/superadmin" component={superadmin} />
                   
                    <Route exact path="/superadmininside" component={superadmininside} />
                    <Route exact path="/superadminstatus" component={superadminstatus} />
                    <Route exact path="/superadminaddress" component={superadminaddress} />
                    <Route exact path="/expert" component={expert} />
                    <Route exact path="/adminfacultyproportion" component={adminfacultyproportion} />
                    <Route exact path="/superadminlistregister" component={superadminlistregister} />
                    <Route exact path="/superadmincertificate" component={superadmincertificate} />

                    <Route exact path="/adminfaculty" component={adminfaculty} />
                    <Route exact path="/adminfacultyi" component={adminfacultyi} />
                    <Route exact path="/adminfacultyst1" component={adminfacultyst1} />
                    <Route exact path="/adminfacultyst2" component={adminfacultyst2} />
                    <Route exact path="/adminfacultyst3" component={adminfacultyst3} />
                    <Route exact path="/adminfacultyst4" component={adminfacultyst4} />
                    <Route exact path="/adminfacultyst5" component={adminfacultyst5} />
                    <Route exact path="/adminfacultyst6" component={adminfacultyst6} />
                    <Route exact path="/adminfacultyst7" component={adminfacultyst7} />
                    <Route exact path="/adminfacultyfortabian" component={adminfacultyfortabian} />
                    <Route exact path="/adminfacultyst8" component={adminfacultyst8} />

                     <Route exact path="/Search" component={Search} />
                    <Route render={function () {return <h1>Not Found</h1> }} />
                </Switch> <br/>

                    </MDBCol>
                </MDBRow>
                </MDBContainer>

               
               {/* <Footter /> */}
            </Router>
        )
    }
}
